import moment from 'moment';
import {
  FREE_PACKAGE_CODES,
  PACKAGE_LEVEL,
  PACKAGE_STUDIO_VERSION,
  PACKAGE_TYPE,
} from '@src/constants/package';

const usePackageData = () => {
  const determinePackageCase = (usingOrders, userInfo) => {
    const hasV3Package = usingOrders.some(
      (order) =>
        order?.package?.version?.includes(PACKAGE_STUDIO_VERSION.V3) &&
        !FREE_PACKAGE_CODES.includes(order?.package?.code) &&
        order?.package?.type === PACKAGE_TYPE.STUDIO,
    );

    const hasCustomPackage = usingOrders.some(
      (order) => order?.package?.level === PACKAGE_LEVEL.CUSTOM,
    );

    const hasV2Package =
      Boolean(userInfo?.remainingCharacters) ||
      usingOrders.some(
        (order) =>
          !order?.package?.version?.includes(PACKAGE_STUDIO_VERSION.V3) &&
          order?.package?.type === PACKAGE_TYPE.STUDIO,
      );

    const hasFreePackage = usingOrders.some((order) =>
      FREE_PACKAGE_CODES.includes(order?.package?.code),
    );

    const isExpired = (packageExpiryDate) =>
      packageExpiryDate && moment(packageExpiryDate).isBefore(moment());

    return {
      hasV3Package,
      hasCustomPackage,
      hasV2Package,
      hasFreePackage,
      showTwoColumnLayout: (hasV3Package || hasCustomPackage) && hasV2Package,
      isExpired,
    };
  };

  return { determinePackageCase };
};

export default usePackageData;
